<div class="mainContent">

  <div style="height: 12vh;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color':buttonColor}">{{titleText}} </label>
      <span class="example-spacer"></span>
    </div>
  </div>
  <div>

      <div style="height: 25vh;padding-left: 0%;padding-right: 4%; margin-left: 10%">
        <form novalidate [formGroup]='FormValidCsv'>
        <div class="row">

          <div class="col-lg-7">
            <div style="display: flex;">
              <mat-form-field appearance="outline">

                <mat-label *ngIf="statevaluechange.action==1" i18n="@@TMshoppingcomplexchooseimage">Choose Qualitative Rationale File</mat-label>
                <mat-label *ngIf="statevaluechange.action==2" i18n="@@TMshoppingcomplexchooseimage">Choose File</mat-label>

                <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Choose File" title="Choose Qualitative Rationale File"
                       formControlName="imageName" id="imageName" [(ngModel)]="statevaluechange.fileName" readonly>
              </mat-form-field>

              <div class="file-field" style="width: 20%;">
                <a class="btn-floating  btn-sm m-0  float-right">
                  <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                  <input type="file" id="imageupload" name="imageupload" (change)="imagePhotofunction($event,'csv','qualitative')"
                         formControlName="imageupload">
                </a>
              </div>

            </div>
          </div>
          <div class="col-lg-5">
            <button i18n="@@TMRunButton" type="button" (click)="uploadZipFile('qualitative')" style="margin-left:2px"
                    [style.background-color]="buttonColor" title="Upload"
                    class="uploadfileButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
              Upload
              <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload example-icon" title="Upload"></em>
            </button>


          </div>

          <div class="col-lg-4"></div>
          <div class="col-lg-4"></div>
        </div>
          <div class="row" *ngIf="statevaluechange.action!=2">

            <div class="col-lg-7">
              <div style="display: flex;">
                <mat-form-field appearance="outline">

                  <mat-label *ngIf="statevaluechange.action==1" i18n="@@TMshoppingcomplexchooseimage">Choose Quantitative Rationale File</mat-label>

                  <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Choose File" title="Choose Quantitative Rationale File"
                         formControlName="quantitativeImageName"  [(ngModel)]="statevaluechange.quantitativeFileName" readonly>
                </mat-form-field>

                <div class="file-field" style="width: 20%;">
                  <a class="btn-floating  btn-sm m-0  float-right">
                    <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                    <input type="file"  name="imageupload" (change)="imagePhotofunction($event,'csv','quantitative')"
                           formControlName="quantitativeImageupload">
                  </a>
                </div>

              </div>
            </div>
            <div class="col-lg-5">
              <button i18n="@@TMRunButton" type="button" (click)="uploadZipFile('quantitative')" style="margin-left:2px"
                      [style.background-color]="buttonColor" title="Upload"
                      class="uploadfileButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
                Upload
                <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload example-icon" title="Upload"></em>
              </button>


            </div>

            <div class="col-lg-4"></div>
            <div class="col-lg-4"></div>
          </div>

        <div class="row">

          <div *ngIf="statevaluechange.action==2"class="col-lg-5" style="text-align: left;font-size: 17px">

            <a [routerLink]="[]" (click)="downloadTemplate()" title="download template">download template</a>
          </div>
          <div class="col-lg-4">

          </div>
        </div>
          <div class="row">
            <div class="col-lg-4">

            </div>
          </div>
          <div class="row">

            <div class="col-lg-4" style="text-align: center;">

            </div>
            <div class="col-lg-8">

            </div>
          </div>

        </form>
      </div>


  </div>

  <div style="height:3vh">
    <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%">
      <div class="col-lg-5"></div>
      <div class="col-lg-7">

          <div style="text-align: end;margin-left: 10%">
            <button i18n="@@TargetCancel" type="button" (click)="closeFunction()" title="Cancel"
                    class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    style="padding: .3rem 1.6rem;font-size: .85rem;" [style.border-color]="buttonColor">
              Cancel
            </button>
            <button i18n="@@TMRunButton" type="button" (click)="processFile()" title="Process"
                    [style.background-color]="buttonColor"
                    class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize">
              Process
            </button>

          </div>
      </div>
    </div>

  </div>
</div>





